export default __webpack_public_path__ + "static/media/previews.91db6b06.gif";